import { Button } from '@mui/material'
import { useTranslate } from '@tolgee/react'
import { CloseButton, Header } from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'
import { FC } from 'react'

type Props = {
  title: string
  onClose: () => void
  onConfirm: () => void
}

export const YardClerkUpdatePositionHeader: FC<Props> = observer(
  ({ title, onClose, onConfirm }) => {
    const { t } = useTranslate()

    return (
      <Header
        title={title}
        titleColor='secondary'
        leftRenderOption={<CloseButton onClose={onClose} />}
        rightRenderOption={
          <Button variant='contained' color='primary' onClick={onConfirm}>
            {t('confirm', 'Confirm')}
          </Button>
        }
      />
    )
  },
)
